import React from 'react';
import LogoTLC from '../assets/logoTLC.jpeg'

function Logo (props) {
  return (
    <div className='logopic'>
    <img src={LogoTLC} alt="Logo"/>
  </div>
  );
}

export default Logo;